// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".collapsed[data-v-6045126d]{visibility:collapse}th[data-v-6045126d]{padding-top:0;padding-bottom:0}th .header-label[data-v-6045126d]{padding-top:16px;padding-bottom:16px}", ""]);
// Exports
module.exports = exports;
